import { FC } from 'react';

import * as Styles from './buttons.styles';

const SmallButton: FC<React.HTMLAttributes<HTMLButtonElement>> = (props) => {
  return (
    <Styles.SmallButton {...props} id={props.id || 'small-button'} />
  );
};

export default SmallButton;
